// @ts-ignore
import { useInView } from "react-intersection-observer";

import AccountCreation from "@/components/signup/account-creation";
import { JPDOverlayTemplate } from "@/components/signup/layouts";
import {
    useFreeIntent,
    usePremiumIntent,
    useStandardIntent
} from "@/components/user-context";
import { useFeatureExposed } from "@/utils/feature-exposed";

import { InputSubmitButton, JPDGetStartedHeading } from "../../components";

import {
    FreeSubheading,
    StandardSubheading
} from "./components/free-subheading";

export const LoggedOutJpd = () => {
    const { ref, inView } = useInView();
    const isStandard = useStandardIntent();
    const isPremium = usePremiumIntent();
    const isFree = useFreeIntent();

    // Only fire useFeatureExposed if user has free, standard, or premium intent
    useFeatureExposed("gwp-7053-jpd-lofi-signup", "Test", {
        conditions: [inView, isFree || isStandard || isPremium],
        metadata: {
            isFree,
            isStandard,
            isPremium,
            userType: "logged-out"
        }
    });

    if (isStandard || isPremium) {
        return (
            <div ref={ref}>
                <LoggedOutJpdStandardPremium />
            </div>
        );
    }

    return (
        <div ref={ref}>
            <LoggedOutJpdFree />
        </div>
    );
};

const LoggedOutJpdFree = () => (
    <JPDOverlayTemplate size="sm">
        <JPDGetStartedHeading />
        <FreeSubheading />
        <AccountCreation Input={<InputSubmitButton />} Submit={null} />
    </JPDOverlayTemplate>
);

const LoggedOutJpdStandardPremium = () => (
    <JPDOverlayTemplate size="sm">
        <JPDGetStartedHeading />
        <StandardSubheading />
        <AccountCreation Input={<InputSubmitButton />} Submit={null} />
    </JPDOverlayTemplate>
);
